import { FC, useState } from "react"
import { useTranslation } from "react-i18next"

import FormField from "components/FormField/FormField"
import Toggle from "components/Toggle/Toggle"
import ViewSettingsModal from "./ViewSettingsModal"
import ViewSettingsFairValueEvaluation from "models/ViewSettingsFairValueEvaluation"

interface IViewSettingsFairValueEvaluationModalProps {
    viewSettings: ViewSettingsFairValueEvaluation
    onClose(): void
    onSave(viewSettings: ViewSettingsFairValueEvaluation): void
}

const ViewSettingsFairValueEvaluationModal: FC<IViewSettingsFairValueEvaluationModalProps> = ({
    viewSettings,
    onClose,
    onSave,
}) => {
    const { t } = useTranslation()
    const [showMachinesOnly, setShowMachinesOnly] = useState(viewSettings.onlyReferenceNumbersWithMachines)

    function resetToDefault() {
        const defaultViewSettings = new ViewSettingsFairValueEvaluation({})
        setShowMachinesOnly(defaultViewSettings.onlyReferenceNumbersWithMachines)
    }

    function handleMachinesOnlyToggle() {
        setShowMachinesOnly(value => !value)
    }

    function handleSave() {
        onSave(new ViewSettingsFairValueEvaluation({
            onlyReferenceNumbersWithMachines: showMachinesOnly,
        }))
        onClose()
    }

    return (
        <ViewSettingsModal
            isDefault={new ViewSettingsFairValueEvaluation({ onlyReferenceNumbersWithMachines: showMachinesOnly }).isDefault}
            onResetToDefault={resetToDefault}
            onSave={handleSave}
            onClose={onClose}>
            <FormField
                label={t("viewSettings.visibilityOfReferenceNumbers")}
                className="pb-4">
                <div className="mt-2">
                    <Toggle
                        label={t("viewSettings.showOnlyWithMachines")}
                        active={showMachinesOnly}
                        testId="show-only-with-machines-toggle"
                        onToggle={handleMachinesOnlyToggle} />
                </div>
            </FormField>
        </ViewSettingsModal>
    )
}

export default ViewSettingsFairValueEvaluationModal
